import React, { Fragment, useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { useRecoilState } from 'recoil';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { alertState } from '../../../../utils/recoil/snackbar';
import { Button } from '../../Elements';

export const Alert = () => {
  const [alert, setAlert] = useRecoilState(alertState);

  useEffect(() => {
    if (alert.show) {
      setTimeout(() => {
        setAlert({ ...alert, show: false });
      }, alert.duration);
    }
  }, [alert.show]);

  const returnNotificationIcon = () => {
    if (alert.type === 'success') {
      return (
        <Icon
          iconKey='HiOutlineCheck'
          color={{ classname: 'green-400' }}
          size='xl'
        />
      );
    } else if (alert.type === 'error') {
      return (
        <Icon
          iconKey='HiOutlineX'
          color={{ classname: 'red-400' }}
          size='xl'
        />
      );
    }
  };

  const returnNotificationColor = () => {
    if (alert.type === 'success') {
      return 'bg-green-50 border-green-400';
    } else if (alert.type === 'error') {
      return 'bg-red-50 border-red-400';
    }
  };

  const handleOnCloseClick = () => {
    setAlert({
      ...alert,
      show: false,
    });
  };

  const returnNotificationPlacement = () => {
    if (alert.placement === 'top-right') {
      return 'top-0 right-0';
    } else if (alert.placement === 'top-left') {
      return 'top-0 left-0';
    } else if (alert.placement === 'bottom-right') {
      return 'bottom-0 right-0';
    } else if (alert.placement === 'bottom-left') {
      return 'bottom-0 left-0';
    } else if (alert.placement === 'top-center') {
      return 'top-0 inset-x-0';
    } else if (alert.placement === 'bottom-center') {
      return 'bottom-0 inset-x-0';
    }
  };

  return (
    <div
      aria-live='assertive'
      className={`fixed ${returnNotificationPlacement()} flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-60`}>
      <div className='w-full  flex flex-col items-center space-y-4 sm:items-end'>
        <Transition
          show={alert.show}
          as={Fragment}
          enter='transform ease-out duration-300 transition'
          enterFrom='translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2'
          enterTo='translate-y-0 opacity-100 sm:translate-x-0'
          leave='transition ease-in duration-100'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'>
          <div
            className={`max-w-sm w-full ${returnNotificationColor()} shadow-lg border-l-4  rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden`}>
            <div className='p-4'>
              <div className='flex items-center'>
                <div className='flex-shrink-0'>{returnNotificationIcon()}</div>
                <div className='ml-3 flex-1 pt-0.5'>
                  <Label
                    as='p'
                    text={alert.title}
                    size='sm'
                    weight='medium'
                  />
                  <Label
                    as='p'
                    text={alert.body}
                    size='sm'
                    weight='medium'
                    color={{ classname: 'gray-500' }}
                  />
                </div>
                <div className='ml-4 flex-shrink-0 flex'>
                  <Button
                    className='bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                    onClick={handleOnCloseClick}
                    size='base'
                    icon={{ iconKey: 'MdClose', size: 'xl' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  );
};
